import styled from 'styled-components';

export const HeaderStyled = styled.header`
    display: flex;
    flex-direction: row;
    gap: var(--space-4);
    justify-content: space-between;
    align-items: center;
    background: var(--app-bg-header-color);
    padding: 0 var(--space-4);
    margin-bottom: var(--space-6);

    .logo {
        cursor: pointer;
        padding: var(--space-5) var(--space-2);
        flex-shrink: 0;
        line-height: 0;

        img {
            display: block;
            width: auto;
            height: 24px;
        }
    }

    .menu {
        flex: 1;
        min-width: 0;
    }
`;

export const HeaderAccountStyled = styled.div`
    display: flex;
    flex-direction: row;
    gap: var(--space-6);
    align-items: center;
    padding: 0 var(--space-2);
    flex-shrink: 0;

    .balance {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 2px;
        white-space: nowrap;
        text-decoration: none;
        color: inherit;
        cursor: pointer;
        border-radius: var(--radius-sm, 4px);
        padding: var(--space-1) var(--space-2);
        margin: calc(-1 * var(--space-1)) calc(-1 * var(--space-2));
        transition: background-color 0.15s ease-in-out;

        &:hover,
        &:focus {
            text-decoration: none;
            color: inherit;
            background: var(--color-surface-highlight, rgba(255, 255, 255, 0.06));
        }

        &:hover .balance-value,
        &:focus .balance-value {
            color: var(--color-accent, var(--color-white-95));
        }
    }

    .balance-label {
        font-size: var(--font-size-xs);
        font-weight: 400;
        color: var(--text-color-secondary);
        line-height: 1.2;
    }

    .balance-value {
        font-size: var(--font-size-md);
        font-weight: 600;
        color: var(--color-white-95);
        line-height: 1.2;
    }

    .logout {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        height: var(--control-height);
        font-size: var(--font-size-md);
        font-weight: 600;

        svg {
            fill: currentColor;
            transition: fill 0.15s ease-in-out;
        }
    }
`;

export const HeaderBurgerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-1);

    a,
    .dropdown-item {
        display: block;
        color: var(--color-white-95);
        text-decoration: none;
        font-weight: 600;
        padding: var(--space-3) var(--space-4);
    }
`;
